import {groupEditors} from "@Common/ui-components/heavy/common/group-editors";

export const groupEnrollmentEditors = (editors) => ({
    ...groupEditors(editors),
    loading: editors?.some((e) => e?.loading),
    needUrgentSaving: editors?.some((e) => e?.changed && e?.needUrgentSaving),
});
